module.exports = {
	"pickup": "Ты поднял ",
	"drop": "Ты положил ",
	"use": "Используй предмет на [ПРОБЕЛ] или (B)",
	"ravens": "Твою на лево, что это было??",
	"wateringcan_name": "лейку",
	"stick_name": "палку",
	"seed_name": "семена",
	"lamp_name": "лампу",
	"shovel_name": "лопату",
	"watering_can": "С её помощью я могу поливать растения, нужно только найти воду",
	"stick": "Из трех палок я могу соорудить костер.\nМне нужно добавлять в костер палки, чтобы он не потух",
	"seed": "Я могу посадить его и дать новую жизнь,\nглавное не забыть что всем растениям нужна вода\nи источник света. Если я сожгу пару семян\nв костре или лампе, они будут светить ярче,\nно не будет ли это эгоистично с моей стороны?",
	"lamp": "С помощью лампы я могу зажечь костер, если в нем будет достаточно веток.\nЕсли сжечь в ней пару семян, она будет гореть ярче, но имею ли я право отбирать жизнь?",
	"shovel": "Лопатой я могу очищать землю от песка\nЯ могу выкопать лунку и посадить в неё семя\nЕсли сквозь песок растет трава, значит под ним есть вода?",
	"wife_0": "[Жена]: В субботу к нам придут друзья.",
	"wife_1": "[Жена]: Не парься, тебя обязательно возьмут.",
	"wife_2": "[Жена]: Чего такой к№слый?",
	"wife_3": "[Жена]: Ты к@к7",
	"wife_4": "[Жен@]: Уга6ай кто отказаckz открывать рот у стом@t0l02@7",
	"wife_5": "[Ж3н@]: Dcnhtnbim vtyz7",
	"wife_6": "[Ж3h@]: Z tle ljvjq gmzytymrfz :*",
	"wife_7": "[}|{3h@]: Z t36z |yu6|yu\"	",
	"kid_0" : "[Ребенок]: Как твой день прошел?",
	"kid_1" : "[Ребенок]: О чём поговорим?",
	"kid_2" : "[Ребен0к]: Когда 8ы ушли мне было страшно",
	"kid_3" : "[Ре6ен0к]: Мам@ ушл\"\" гулять с соб@кой7",
	"kid_4" : "[Р363н0к]: Отсn@нь от м3ня|",
	"kid_5" : "[Р363h0к]: Z k.,k. dfc, ds pyftnt 'nj&",
	"kid_6" : "[R363h0к]: Z p0 8@m 04e№\"\" $|{Y4@yu\"",
	"parents_0" : "[Родители]: Когда ты приедешь?",
	"parents_1" : "[Родители]: Ты так изменился...",
	"parents_2" : "[Роdители]: Я н3 могу разговаривать с в@шим 0тцом",
	"parents_3" : "[Р0dители]: ПочеvY tы постоzyyj спориim cj vyjq&",
	"parents_4" : "[Р0d\"\"t3л\"\"]: Csyjr? z k.,k. nt,z",
	"parents_5" : "[R0d\"\"t3|\"\"]: $p@$\"\"60 4t0 p0380№\"\"1\"",
	"friends_0" : "[Друзья]: Здоров как сам?",
	"friends_1" : "[Друзья]: Не надумал ещё вернуться?",
	"friends_2" : "[Дру3ья]: Г0 играtь?",
	"friends_3" : "[Dру3'я]: У3н@ли к@кой по|?",
	"friends_4" : "[DRY3'z]: mh3 эt0 h3 \"\"ht3R3$h0\"",
	"author_0" : "[Э.М.Ремарк]: Таков человек: по-настоящему он дорожит только тем,\nчто у него отнято.",
	"author_1" : "[Э.М.Ремарк]: Никогда не следует искушать свое счастье.",
	"author_2" : "[Э.М.Ремарк]: Любовь – это желание передать дальше то, чего не можешь удержать.",
	"author_3" : "[Э.М.Ремарк]: Все ужасы можно пережить, пока ты просто покоряешься своей судьбе,\nно попробуй размышлять о них – и они убьют тебя.",
	"author_4" : "[Э.М.Ремарк]: Предаваться унынию можно лишь до тех пор,\nпока дела идут еще не совсем скверно.",
	"author_5" : "[Э.М.Ремарк]: Ожидаешь чудес, а потом все сводится к буханке хлеба.",
	"colleague_0" : "[Коллега]: Скоро отпуск, не запаривайся",
	"colleague_1" : "[Коллега]: Старшой сегодня лютует",
	"colleague_2" : "[К0ллега]: Да и поcfa8y8o",
	"colleague_3" : "[К0ллег@]: tы ^R@вильh0 ^0$tY^ил",
	"colleague_4" : "[К0||е2@]: }{0R0|||320 0t^Y$|{@",
	"colleague_5" : "[|{0||32@]: V$3 6Yd3t h3 3@m0R@4\"\"v@y'$z\"",
	"pet_0" : "[Питомец]: Скулит",
	"pet_1" : "[Питомец]: Лает",
	"pet_2" : "[Пит0мец]: Чеш3т уши",
	"pet_3" : "[Пит0м3q]: Mrrrrrrr",
	"pet_4" : "[Пиt0m3q]: Nhtncz yjcjv",
	"pet_5" : "[P\"\"t0m3q]: R@d v\"\"d3t'",
	"memory_zakolka": "Мы были в зоопарке и сделали там это фото.\nТогда нас было ещё трое, но спустя год у нас было прибавление.",
	"memory_kulon": "Этот кулон достался маме ещё от её бабушки",
	"memory_guitar": "Я не умею играть на гитаре, но часто брал её,\nкогда мы уезжали с друзьями на отдых.",
	"memory_gamepad": "Друзья часто звали меня играть по сети, порой\nу меня не было времени на это.",
	"memory_book": "Я любил разные жанры, но последнее время читал\nтолько антивоенную литературу.",
	"memory_badge": "Я был рад работать в этой команде и оставил его\nкак сувенир, когда компания закрылась",
	"memory_miska": "Кот постоянно ронял миску на пол и начинал орать,\nлишившись еды. Он прожил с нами достаточно долго, по кошачьим меркам."
}